import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { NewValuationPageComponent } from './features/valuation/new-valuation-page/new-valuation-page.component';
import { ValuationsPageComponent } from './features/valuation/valuations-page/valuations-page.component';
import { ValuationSessionPageComponent } from './features/valuation/valuation-session-page/valuation-session-page.component';
import { PropertyFactsTabComponent } from './features/valuation/property-facts-tab/property-facts-tab.component';
import { SubjectLocationTabComponent } from './features/valuation/subject-location-tab/subject-location-tab.component';
import { TaxBillTabComponent } from './features/valuation/tax-bill-tab/tax-bill-tab.component';
import { ComparablesTabComponent } from './features/valuation/comparables-tab/comparables-tab.component';
import { IncomeApproachTabComponent } from './features/valuation/income-approach-tab/income-approach-tab.component';
import { canDeactivateGuard } from './routing/can-deactivate.guard';
import { AuthCallbackPageComponent } from './features/auth/auth-callback-page/auth-callback-page.component';
import { LoginPageComponent } from './features/auth/login-page/login-page.component';
import { SalesCloserPageComponent } from './features/sales/sales-closer-page/sales-closer-page.component';
import { SalesPageComponent } from './features/sales/sales-page/sales-page.component';
import { DYNAMIC_TITLE } from './routing/route-info-title-strategy';
import {
  ValuationCompleteTabComponent
} from './features/valuation/valuation-complete-tab/valuation-complete-tab.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'valuations', title: 'Propraize' },
  {
    path: 'login',
    component: LoginPageComponent,
    title: 'Authentication',
    data: { summary: 'Start the sign-in flow and inspect current auth responses.' },
  },
  {
    path: 'auth',
    component: AuthCallbackPageComponent,
    title: 'Signing in',
    data: { summary: 'Complete Microsoft Entra ID sign-in and verify the authenticated user.' },
  },
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      {
        path: 'sales',
        component: SalesPageComponent,
        title: 'Sales',
        data: { summary: 'Tools for the sales team to prepare and close prospect deals.' },
        children: [
          {
            path: 'closer-document',
            component: SalesCloserPageComponent,
            title: 'Closer Tool',
            data: {
              summary: 'Generate a branded closer document (ROI analysis or portfolio summary) from a valuation Excel file.',
            },
          },
        ],
      },
      {
        path: 'valuations',
        component: ValuationsPageComponent,
        title: 'Valuations',
        data: { summary: 'Start a new valuation or resume one already in progress.' },
      },
      {
        path: 'valuations/new',
        component: NewValuationPageComponent,
        title: 'New valuation',
        data: { summary: 'Create a new multifamily valuation session.' },
      },
      {
        path: 'valuations/:sessionId',
        component: ValuationSessionPageComponent,
        title: 'Valuation session',
        data: { summary: 'Review property facts and valuation results for this session.' },
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'property-facts' },
          {
            path: 'property-facts',
            component: PropertyFactsTabComponent,
            title: DYNAMIC_TITLE,
            canDeactivate: [canDeactivateGuard],
          },
          { path: 'subject-location', component: SubjectLocationTabComponent, title: DYNAMIC_TITLE },
          { path: 'tax-bill', component: TaxBillTabComponent, title: DYNAMIC_TITLE },
          { path: 'comparables', component: ComparablesTabComponent, title: DYNAMIC_TITLE },
          {
            path: 'income-approach',
            component: IncomeApproachTabComponent,
            title: DYNAMIC_TITLE,
            canDeactivate: [canDeactivateGuard],
          },
          { path: 'complete', component: ValuationCompleteTabComponent, title: DYNAMIC_TITLE },
        ],
      },
    ],
  },
  { path: '**', redirectTo: 'valuations', title: 'Propraize' },
];
